import { useEffect, useState } from 'react';
import i18n from '../i18n';

/** BCP-47 locale for Intl; updates when the user changes language. */
export function useI18nLanguage(): string {
  const [lng, setLng] = useState(() => i18n.resolvedLanguage || i18n.language || 'en');

  useEffect(() => {
    const onChange = (l: string) => setLng(l);
    i18n.on('languageChanged', onChange);
    return () => {
      i18n.off('languageChanged', onChange);
    };
  }, []);

  return lng;
}
